export const statusesTableColumns = [
  {
    prop: 'name',
    title: 'common.fields.name',
    width: '22%',
    sortingEnabled: true,
  },
  {
    prop: 'description',
    title: 'common.fields.description',
    width: '58%',
    sortingEnabled: true,
  },
  {
    prop: 'count_of_dates',
    title: 'adm.permits.table_headers.dates_count',
    width: '10%',
    sortingEnabled: false,
  },
  {
    prop: 'actions',
    title: 'common.fields.actions',
    width: '10%',
    sortingEnabled: false,
  },
];
